import axios, { baseURL } from '@axios'
import { paginateArray, sortCompare } from '@/common'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchSaleOrders(ctx, queryParams) {
      console.log('queryOrder order', queryParams)
      const payload = {
        pagination: {
          total: 0,
          current: 0,
          pageSize: 10000,
        },
        search: {
          saleOrderNo: null,
          startPrice: null,
          endPrice: null,
          shopId: null,
          categoryId: null,
        },
        sort: {
          predicate: '',
          reverse: true,
        },
      }
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/SaleOrder/GetOrderList`, payload)
          .then(response => {
            console.log('res', response)
            const {
              q = '',
              perPage = 10,
              page = 1,
              sortBy = 'saleOrderId',
              sortDesc = false,
              status,
              plan,
            } = queryParams

            let dataFromAPI = response.data.data.list

            if (status) {
              dataFromAPI = dataFromAPI.filter(user => user.status == (status == 'active'))
            }

            if (plan) {
              dataFromAPI = dataFromAPI.filter(user => user.customerId == plan)
            }

            console.log('res1', dataFromAPI)

            if (q !== '' && q !== null) {
              const queryLowered = q.toLowerCase()
              const result = []
              dataFromAPI.forEach(x => {
                console.log(x)
                const no = x.no || ''
                const TrackingID = x.TrackingID || ''
                const createdOnString = x.createdOnString || ''
                const customerName = x.customerName || ''
                const customerPhone = x.customerPhone || ''
                const orderTotal = x.orderTotal || ''
                const orderStatusString = x.orderStatusString || ''

                if (no.toString().toLowerCase().includes(queryLowered)
    || TrackingID.toString().toLowerCase().includes(queryLowered)
    || createdOnString.toString().toLowerCase().includes(queryLowered)
    || customerName.toString().toLowerCase().includes(queryLowered)
    || customerPhone.toString().toLowerCase().includes(queryLowered)
    || orderTotal.toString().toLowerCase().includes(queryLowered)
    || orderStatusString.toString().toLowerCase().includes(queryLowered)
                ) {
                  result.push(x)
                }
              })
              dataFromAPI = result
            }

            console.log('res2', dataFromAPI)
            const sortedData = dataFromAPI.sort(sortCompare(sortBy))
            if (sortDesc) sortedData.reverse()
            resolve({
              data: paginateArray(sortedData, perPage, page),
              totalCount: dataFromAPI.length,
            })
          })
          .catch(error => reject(error))
      })
    },
    fetchSaleOrder(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${baseURL}/api/SaleOrder/GetOrderById`, {
            params: {
              id,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addSaleOrder(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/SaleOrder/AddOrUdpate`, { userData })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteSaleOrder(ctx, { id, status }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`${baseURL}/api/SaleOrder/Delete`, {
            params: {
              saleOrderId: id,
              status,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getContract() {
      return new Promise((resolve, reject) => {
        axios
          .get(`${baseURL}/api/Contact/Get`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
